module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/json/stringify.js
// module id = 43
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/babel-runtime/core-js/json/stringify.js